export default __webpack_public_path__ + "static/media/vitalik_poap_17.ff1355a3.svg";